import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between card-header" }
const _hoisted_2 = { class: "text-base font-bold" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Status")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Product Cost")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Shipping Cost:")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Addition Charge:")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Refund:")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Total:")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_OrderStatusTag = _resolveComponent("OrderStatusTag")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createBlock(_component_el_card, null, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.title), 1)
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_row, {
        gutter: 24,
        hidden: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 12 }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            span: 12,
            class: "text-right"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_OrderStatusTag, {
                order: { status: _ctx.order.status, comment: _ctx.order.comment }
              }, null, 8, ["order"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, { gutter: 24 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, {
            span: 12,
            class: "mt-2"
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            span: 12,
            class: "text-right mt-2"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.formatterDollars(_ctx.order.sellerBaseCost)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 12 }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            span: 12,
            class: "text-right"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.formatterDollars(_ctx.order.sellerShippingCost)), 1)
            ]),
            _: 1
          }),
          (_ctx.order.additionChargeAmount > 0)
            ? (_openBlock(), _createBlock(_component_el_col, {
                key: 0,
                span: 12
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.order.additionChargeAmount > 0)
            ? (_openBlock(), _createBlock(_component_el_col, {
                key: 1,
                span: 12,
                class: "text-right"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.formatterDollars(_ctx.order.additionChargeAmount)), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.order.refundAmount > 0)
            ? (_openBlock(), _createBlock(_component_el_col, {
                key: 2,
                span: 12
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.order.refundAmount > 0)
            ? (_openBlock(), _createBlock(_component_el_col, {
                key: 3,
                span: 12,
                class: "text-right"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" -" + _toDisplayString(_ctx.formatterDollars(_ctx.order.refundAmount)), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_col, {
            span: 12,
            class: "font-bold mt-2"
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            span: 12,
            class: "font-bold text-right mt-2"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.formatterDollars(_ctx.order.sellerAmount)), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}